// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MangoHubGetPatientSummaryDetails } from './mangoHubGetPatientSummaryDetails.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MangoHubGetPatientAccountSummary {
    'patientSummaryDetails': MangoHubGetPatientSummaryDetails | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MangoHubGetPatientAccountSummary>> = [
        {
            "name":     "patientSummaryDetails",
            "baseName": "patientSummaryDetails",
            "type":     "MangoHubGetPatientSummaryDetails"
        },
    ];

    static getAttributeTypeMap() {
        return MangoHubGetPatientAccountSummary.attributeTypeMap;
    }
}
